import React, { Component } from "react";
import LiveViewMap from "../../components/liveViewMap";
import { fetchQLTripsInBatches } from "../../utils/qlTrips";

class LiveView extends Component {
  state = {
    loading: true,
    trips: []
  };

  async componentDidMount() {
    try {
      const trips = await this.fetchOntrip();
      this.setState({ loading: false, trips });
    } catch (err) {
      console.log(err);
    }
  }

  fetchOntrip = async () => {
    try {
      // Only ONTRIP trips are shown here, so skip the ACTIVE/COMPLETED batches.
      return await fetchQLTripsInBatches({}, null, ["ONTRIP"]);
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  onTripCountChange = async () => {
    try {
      const trips = await this.fetchOntrip();
      this.setState({ loading: false, trips });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { trips, loading } = this.state;

    return (
      <div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <LiveViewMap
              trips={trips}
              onTripCountChange={this.onTripCountChange}
            />{" "}
          </>
        )}
      </div>
    );
  }
}

export default LiveView;
